import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import Layout from "src/components/layout/Layout";
import useAuth from "src/hooks/selectors/useAuth";
import useTask from "src/hooks/api/tasks/useTask";
import TasksDetailEventView from "src/views/authenticated/tasks/detail/TasksDetailEventView";
import useTaskFormAutoSave from "src/hooks/api/tasks/useTaskFormAutoSave";
import TaskPublishView from "src/views/authenticated/tasks/detail/publish/TaskPublishView";
import TasksDetailNormalView from "src/views/authenticated/tasks/detail/TasksDetailNormalView";

export default function TasksDetailView() {
	const { id, pane } = useParams() as any;
	const auth = useAuth();
	const location = useLocation();
	const { task, actions, status } = useTask();
	useTaskFormAutoSave(["publish", "edit"].includes(pane));

	useEffect(() => {
		return () => {
			actions.clear();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!task?.id || task?.hid !== id) {
			actions.get();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	if (status === "loading") {
		return (
			<Layout
				{...actions.getHeadProps()}
				loading={status === "loading"}
			></Layout>
		);
	}

	//Disable for task create thanks page
	if (id === "create" && pane === "completed") {
		return <></>;
	}

	if (
		pane === "show" &&
		task.variant === "HOUR_RATE" &&
		auth.type === "company"
	) {
		return <TasksDetailEventView />;
	}

	if (pane === "publish" && auth.type === "company") {
		return <TaskPublishView />;
	}

	return <TasksDetailNormalView />;
}
